import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the CRM service worker ONLY on the /admin/* routes. The public site
// must always serve the freshest bundle, so we actively unregister any legacy
// SW on public routes to purge stale HTML from earlier caches.
try {
  if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
    const isAdmin = typeof window !== "undefined" && window.location && window.location.pathname.startsWith("/admin");
    window.addEventListener("load", () => {
      try {
        if (isAdmin) {
          navigator.serviceWorker.register("/service-worker.js").catch(() => {});
        } else {
          // Public site: nuke any previously-registered SW + its caches so
          // returning visitors always get the newest deploy.
          navigator.serviceWorker.getRegistrations().then((regs) => {
            regs.forEach((r) => {
              if (!r.scope || !r.scope.includes("/admin")) r.unregister().catch(() => {});
            });
          }).catch(() => {});
          if (typeof caches !== "undefined") {
            caches.keys().then((keys) => keys.forEach((k) => {
              if (k && k.startsWith("propertic")) caches.delete(k).catch(() => {});
            })).catch(() => {});
          }
        }
      } catch (_e) {
        // no-op: some WebViews reject SW registration synchronously
      }
    });
  }
} catch (_e) {
  // no-op
}

// Global safety net: some iOS WebViews raise cross-origin "Script error." for
// unrelated third-party frames. Swallow those so they don't trigger the CRA
// dev-mode error overlay while advisors are using the CRM.
if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    if (!e || !e.message || e.message === "Script error.") {
      e.stopImmediatePropagation && e.stopImmediatePropagation();
      e.preventDefault && e.preventDefault();
    }
  });
  window.addEventListener("unhandledrejection", (e) => {
    // Never let promise rejections bubble to CRA overlay in preview builds.
    try { e.preventDefault && e.preventDefault(); } catch {}
  });
}
